import { render, staticRenderFns } from "./SeriesSummary.vue?vue&type=template&id=004675e5"
import script from "./SeriesSummary.vue?vue&type=script&lang=js"
export * from "./SeriesSummary.vue?vue&type=script&lang=js"
import style0 from "./SeriesSummary.vue?vue&type=style&index=0&id=004675e5&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004675e5')) {
      api.createRecord('004675e5', component.options)
    } else {
      api.reload('004675e5', component.options)
    }
    module.hot.accept("./SeriesSummary.vue?vue&type=template&id=004675e5", function () {
      api.rerender('004675e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SeriesSummary.vue"
export default component.exports